(function() {
    'use strict';
 
a3_pilot_reports.run(runBlock);

/* @ngInject */ 
function runBlock($rootScope, $timeout, $location, UserFactory, UserTokenFactory,PilotReportLocalEditFactory,SettingsMain,$anchorScroll,SWUpdateService,LogService) {
	//make sure that each route change validates that the user is still logged in
	var valid=['/login','/reset','/debug','/ticket'];
    $rootScope.$on('$routeChangeStart', function (event, next, current) {
        if (valid.indexOf($location.$$path) < 0  && !UserFactory.isLoggedIn()) {
            event.preventDefault();
            $location.path('/login');
        }

        //START - SERVICE WORKERS
        if ('serviceWorker' in navigator) {
            SWUpdateService.initialize();
            
            navigator.serviceWorker.getRegistration().then(function(registration) {
                $rootScope.SWRegistration = registration;
            });

            SWUpdateService.checkUpdates($rootScope.SWRegistration);
        }
        //END - SERVICE WORKERS
        
        $anchorScroll.yOffset = 100;
        if(valid.indexOf($location.$$path) < 0 && (!current || !current.$$route || !next.$$route || current.$$route.controller != next.$$route.controller)){
        //Check if temp report of any kind exists
        var editingPage = SettingsMain.getEditingPage();
        SettingsMain.setEditingPage(null);
        
        if (editingPage == 'report') 
        {
            // check if a temp report exists in local storage
            if (PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp() != null) {
                $location.path("report/temp");
            }
        } 
    }
        
    });
    
    $("body").on("click",".memo-body a", function(){
        var link = $(this).attr("href");
        if (link && link.indexOf("surveymonkey")>0){
            LogService.debug(link);
        }
        
    })
      
    $rootScope.idbSupported = ("indexedDB" in window);
    $rootScope.isOffline = !window.navigator.onLine;
    
    window.addEventListener('offline', function (e) { $timeout($rootScope.isOffline = !window.navigator.onLine); });
    window.addEventListener('online', function (e) { $timeout($rootScope.isOffline = !window.navigator.onLine); });

	//maintain the user token, outside the localStorage, needed for submitting js errors
	var user = UserFactory.getUser();
	if (user && user.token) UserTokenFactory.setToken(user.token);
	else UserTokenFactory.setToken('');
};

 
 })();   